module.exports = __webpack_public_path__ + "img/1539012851.7ad8c573.jpg";